module.exports = __webpack_public_path__ + "img/cover-socialphoto.a0b6b754.png";